<template>
    <div class="d-flex all-after-header-box">
        <!-- Левое меню модуля -->
        <div 
            :class="{'drawer-left-wrap' : true, 'dlw-large' : (!drawerLeftMenuMini), 'drawer-menu-hover': drawerLeftMenuHover }"
            @mouseenter="LeftMenuMouseenter()"
            @mouseleave="LeftMenuMouseleave()"
        >
            <v-navigation-drawer
                absolute
                permanent
                class="drawer-menu"
                v-model="drawerLeftMenu"
            >

                <template v-if="allowCreateNPA">
                    <v-divider class="mr-2 ml-2"></v-divider>

                    <v-list
                        nav
                        dense
                        class="dm-actions-list"
                    >
                        <v-list-item-group
                            color="#009c95"
                        >
                            <v-list-item 
                                link
                                class="v-item--active v-list-item--active drawer-menu-list-bigbtn"
                                @click="onCreateClicked"
                            >
                                <v-list-item-icon>
                                    <v-icon>mdi-plus-box</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Добавить") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </template>

                <v-divider class="mr-2 ml-2"></v-divider>

                <v-list
                    nav
                    dense
                    shaped
                >
                    <v-list-item-group>
                        <v-list-item
                            link
                            :to="{ name: 'NPAProjectsList' }"
                        >
                            <v-list-item-icon>
                            <v-icon>far fa-clipboard-list</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Проекты") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" class="dm-counter">{{ ProjectsCount }}</div>
                        </v-list-item>

                        <v-list-item
                            link
                            :to="{ name: 'NPASolutionsList' }"
                        >
                            <v-list-item-icon>
                            <v-icon>far fa-poll</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Решения") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" class="dm-counter">{{ SolutionsCount }}</div>
                        </v-list-item>

                        <v-list-item
                            link
                            :to="{ name: 'NPAResolutionsList' }"
                        >
                            <v-list-item-icon>
                            <v-icon>far fa-landmark</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Постановления") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" class="dm-counter">{{ ResolutionsCount }}</div>
                        </v-list-item>

                        <v-list-item
                            link
                            :to="{ name: 'NPAOrdersList' }"
                        >
                            <v-list-item-icon>
                            <v-icon>far fa-file-signature</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t("Распоряжения") }}</v-list-item-title>
                            <div v-if="!drawerLeftMenuMini" class="dm-counter">{{ OrdersCount }}</div>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>

            </v-navigation-drawer>
        </div>

        <div class="content-box">

            <router-view :key="category" />
            
        </div>

        <CreateNpaDocumentModal ref="CreateDlg"/>

    </div>
</template>

<script>
import CreateNpaDocumentModal from '@/components/npa/dialogs/CreateNpaDocumentDlg.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "Orders",
    components: {
        CreateNpaDocumentModal
    },
    computed: {
        ...mapGetters({ drawerLeftMenuMini: 'isDrawerLeftMenuMinimized' }),
        ...mapGetters('global/actionsource', ['getDataSourceType', 'isDataSourceNewRecord'] ),
        ...mapGetters('npa', {
            ProjectsCount: 'getProjectsCount',
            SolutionsCount: 'getSolutionsCount',
            ResolutionsCount: 'getResolutionsCount',
            OrdersCount: 'getOrdersCount',
            category: 'getCategory'
        }),
        allowCreateNPA(){
            let checker = (arr, target) => target.some(v => arr.includes(v));
            return checker(this.$store.getters['global/auth/getUserInfo'].Permissions, ["CreateNPA", "CreateAcceptedNPA"]);
        },
    },
    data: () => ({
        drawerLeftMenu: true,
        drawerLeftMenuHover: false,
    }),    
    methods: {
        ...mapActions('global/actionsource', ['loadDataSource']),
        ...mapActions('npa', ['updateCounter']),
        LeftMenuMouseenter() {
            if (this.drawerLeftMenuMini)
                this.drawerLeftMenuHover = true;
        },
        LeftMenuMouseleave() {
            this.drawerLeftMenuHover = false;  
        },
        async onCreateClicked() {
            try
            {
                let { params } = await this.$refs.CreateDlg.open();
                await this.loadDataSource({ createType: params.createType, navigate: true, common: params.isCommon ?? false });
            }
            catch (ex)
            {
                console.log(ex);
            }
        },
    },
    async mounted() {
        await this.updateCounter();
    }
}
</script>